import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daglbsptto0ceqqnhujg";

type Status = { kind: "idle" } | { kind: "ok"; msg: string } | { kind: "err"; msg: string };

export default function SubscribeForm({ compact = false }: { compact?: boolean }) {
  const [status, setStatus] = useState<Status>({ kind: "idle" });
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (pending) return;
    const fd = new FormData(e.currentTarget);
    const hp = String(fd.get("contact_alt") || "").trim();
    if (hp) {
      setStatus({ kind: "ok", msg: "订阅成功！新面孔瓜更新会第一时间送到你邮箱。" });
      e.currentTarget.reset();
      setEmail("");
      return;
    }
    const payload = new URLSearchParams();
    const real = String(fd.get("email") || "").trim();
    if (real) payload.append("email", real);
    setPending(true);
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await res.text();
      let code = "";
      let msg = "";
      try {
        const parsed = JSON.parse(text);
        code = parsed?.code || "";
        msg = parsed?.meta?.message || parsed?.message || "";
      } catch {
        code = "";
      }
      if (res.ok && code === "OK") {
        setStatus({ kind: "ok", msg: "订阅成功！新面孔瓜更新会第一时间送到你邮箱。" });
        e.currentTarget.reset();
        setEmail("");
      } else {
        setStatus({ kind: "err", msg: msg || "订阅失败，请稍后再试。" });
      }
    } catch {
      setStatus({ kind: "err", msg: "网络开小差了，请稍后再试。" });
    } finally {
      setPending(false);
    }
  }

  return (
    <form onSubmit={onSubmit} data-readdy-form="新瓜档案-订阅更新" className="w-full">
      <div className={compact ? "" : "space-y-3"}>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <label htmlFor="subscribe-email" className="sr-only">邮箱地址</label>
          <input
            id="subscribe-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            placeholder="输入你的邮箱地址"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
          <button type="submit" disabled={pending} className="btn whitespace-nowrap bg-primary-500 px-6 text-background-50 hover:bg-primary-600 disabled:opacity-60">
            {pending ? "提交中…" : "立即订阅"}
            <i className="ri-send-plane-line" />
          </button>
        </div>
        <div aria-hidden="true" className="form-aux-field">
          <input name="contact_alt" type="text" tabIndex={-1} autoComplete="off" readOnly />
        </div>
        {status.kind === "ok" && (
          <p className="flex items-center gap-1.5 text-sm text-secondary-700"><i className="ri-checkbox-circle-line" />{status.msg}</p>
        )}
        {status.kind === "err" && (
          <p className="flex items-center gap-1.5 text-sm text-primary-600"><i className="ri-error-warning-line" />{status.msg}</p>
        )}
      </div>
    </form>
  );
}